import { useState } from "react";
import { toast } from "sonner";
import { Gift } from "@phosphor-icons/react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const RedeemGiftCard = ({ onDone }) => {
  const { refreshUser } = useAuth();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const redeem = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/gifts/redeem", { code });
      await refreshUser();
      toast.success(`Gift redeemed — a present from ${r.data.from_name}. Every Life Season is now yours.`);
      onDone?.();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "We couldn't redeem that code.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={redeem} data-testid="redeem-gift-card" className="rounded-2xl bg-[#EBF4F5] p-5 sm:p-6">
      <p className="flex items-center gap-2 font-serif text-xl text-[#245E63]"><Gift size={20} weight="duotone" /> Have a gift code?</p>
      <p className="mt-1 text-sm text-[#4A4540]">Enter the code from your gift certificate to unlock every Life Season.</p>
      <div className="mt-4 flex flex-col gap-2 sm:flex-row">
        <input data-testid="redeem-code-input" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} maxLength={20}
          placeholder="GIFT-XXXX-XXXX" autoComplete="off"
          className="min-w-0 flex-1 rounded-full border border-[#36858B]/30 bg-white px-5 py-3 font-mono text-base tracking-wider focus:outline-none focus:ring-2 focus:ring-[#36858B]/40" />
        <button data-testid="redeem-submit" disabled={busy || code.replace(/[^A-Z0-9]/g, "").length < 12}
          className="rounded-full bg-[#36858B] px-6 py-3 text-sm font-semibold text-white hover:bg-[#245E63] disabled:opacity-50">
          {busy ? "Redeeming…" : "Redeem gift"}
        </button>
      </div>
    </form>
  );
};
